import { getFileNameFromContentDisposition } from '@/shared/utils/getFileNameFromContentDisposition';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export interface MonitoringFileDownload {
  blob: Blob;
  fileName?: string;
}

export class MonitoringService extends HttpClientAdapter {
  constructor() {
    super('MONITORING');
  }

  getFile<Response>(id: string) {
    return this.get<Response>(`/files/${id}`);
  }

  /**
   * Baixa o arquivo original de um File via `GET /files/:id/download`.
   *
   * A resposta é binária (`responseType: 'blob'`) e o nome do arquivo é extraído do
   * header `Content-Disposition`. Caso o header não esteja acessível (ex.: por CORS),
   * o `fallbackFileName` informado é utilizado.
   *
   * Usa a instância axios da base (com base URL e interceptors de auth já configurados),
   * pois precisamos acessar os headers da resposta — que o método `request` padrão não expõe.
   */
  async downloadFile(id: string, fallbackFileName?: string): Promise<MonitoringFileDownload> {
    const response = await this.getAxiosInstance().request<Blob>({
      url: this.getFullURL(`/files/${id}/download`),
      method: 'get',
      responseType: 'blob',
    });

    const contentDisposition = response.headers?.['content-disposition'] as string | undefined;
    const fileName = getFileNameFromContentDisposition(contentDisposition, fallbackFileName);

    return {
      blob: response.data,
      fileName,
    };
  }

  getFiles<Response, Filters>(params: Filters) {
    return this.get<Response, Filters>('/files', params);
  }

  getRows<Response, Filters>(params: Filters) {
    return this.get<Response, Filters>('/rows', params);
  }
}
